import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import Calendar from "@/components/shared/Calendar.vue";
import InlineSvg from "vue-inline-svg";


const __default__ = {
  name: "TargetCalendarInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  title: {
    type: String,
  },
  selectedDate: {
    type: String,
    default: "",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  required: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: "",
  },
  dateFormat: {
    type: String,
    default: "YYYY.MM.DD(dd)",
  },
  hasTimeSelect: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onSelectDate"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

dayjs.locale("ko");
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Seoul");

const props = __props;

const emit = __emit;

const formattedSelectedDate = computed(() =>
  props.selectedDate ? dayjs(props.selectedDate).format(props.dateFormat) : ""
);

const showCalendar = ref(false);
const toggleCalendar = (show: boolean) => {
  if (props.disabled) return;
  showCalendar.value = show;
};

const onSelectDate = (date: string) => {
  emit("onSelectDate", date);
  toggleCalendar(false);
};

const titleRef = ref<HTMLElement>();
const titleHeight = computed(() => {
  return `${titleRef.value?.clientHeight ?? 0}px`;
});

const __returned__ = { props, emit, formattedSelectedDate, showCalendar, toggleCalendar, onSelectDate, titleRef, titleHeight, Calendar, get InlineSvg() { return InlineSvg } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})